export default "__VITE_ASSET__89a25693__"